import React from 'react';
import { Box, Stack, styled, Toolbar, BoxProps, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import { useRecoilValue } from 'recoil';
import { tenantInfoState } from 'modules/application/atoms';

const FooterContainer = styled(Box)<BoxProps>(({ theme }) => ({
  minHeight: theme.spacing(6),
  borderTopStyle: 'solid',
  borderTopWidth: '1px',
  borderTopColor: theme.palette.grey[300],
  backgroundColor: theme.palette.background.paper
}));

export const Footer: React.FC = () => {
  const { formatMessage } = useIntl();
  const tenantInfo = useRecoilValue(tenantInfoState);

  return (
    <FooterContainer component='footer'>
      <Toolbar>
        <Stack color='text.secondary' direction={{ xs: 'column', sm: 'row' }} alignItems='center' justifyContent="space-between" flexGrow={1}>
          <Typography variant='body2' textAlign='right'>© {dayjs().year()} | {tenantInfo.name} | {formatMessage({ id: 'Footer.Copyright', defaultMessage: 'All rights reserved.' })}</Typography>
          <Typography variant='body2' textAlign='right'>{formatMessage({ id: 'Footer.Version', defaultMessage: 'Version' })} {process.env.REACT_APP_VERSION}</Typography>
        </Stack>
      </Toolbar>
    </FooterContainer>
  );
};